// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".PageNavigation-tabs__w13s4{display:flex;align-items:center;height:var(--size-12);padding:0 var(--size-4)}.PageNavigation-views__XGs3p{width:var(--size-full)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tabs": "PageNavigation-tabs__w13s4",
	"views": "PageNavigation-views__XGs3p"
};
export default ___CSS_LOADER_EXPORT___;
